/**
 * Shared Two-Factor Authentication types used across profile and login flows.
 */
export enum TwoFactorMethod {
  EMAIL = 'EMAIL',
  APP = 'APP',
  SMS = 'SMS',
}
